module.exports = __webpack_public_path__ + "static/media/none.4887231f.svg";